<template>
    <div class="chart-container">
        <div class="chart-header">
            <p class="chart-subtitle">Média de notas por instituição (Total: {{ mediaAll.length }} instituições)</p>
        </div>

        <loading v-if="isLoading" />


        <div v-if="!showTable" class="chart-wrapper">
            <div class="optionsContainer">
                <div v-if="imsFiltrados.length">
                    <input v-model="searchQuery" placeholder="Filtrar por nome da escola..." class="search-input">
                    <select v-model="sortOption" class="sort-select">
                        <option value="name-asc">Nome (A-Z)</option>
                        <option value="name-desc">Nome (Z-A)</option>
                        <option value="score-asc">Média (Baixa-Alta)</option>
                        <option value="score-desc">Média (Alta-Baixa)</option>
                    </select>
                </div>

                <div style="display: flex; flex-direction: row;">
                    <v-select class="year-select" :items="anoLectivoAll" v-model="anoLectivoSelected"
                        @change="carregarDados()" item-value="descricao" item-text="novadescricao" label="Ano Lectivo"
                        outlined dense hide-details></v-select>

                    <v-select class="year-select" :items="visualizacao" v-model="visualizacaoSelected"
                        @change="mudarVisualizacao()" item-value="id" item-text="descricao" label="Visualização"
                        outlined dense hide-details></v-select>
                    <v-select class="year-select" v-if="imsFiltrados.length"  :items="imsFiltrados" v-model="imsAssociadoSelect"
                        @change="filtrarIMS()" item-value="descricao" item-text="descricaoFilhacao" label="Colégios"
                        outlined dense hide-details></v-select>
                </div>
            </div>


            <div class="chart-controls">
                <div class="search-filter">
                    <div class="view-toggle">
                    </div>
                </div>

                <div class="pagination-controls" v-if="paginatedData.length > itemsPerPage">
                    <button @click="prevPage" :disabled="currentPage === 1">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <span>Página {{ currentPage }} de {{ totalPages }}</span>
                    <button @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <div class="chart-area">
                <BarChart :chart-data="filteredChartData" :options="chartOptions" class="chart"
                    v-if="filteredLabels.length > 0" />

                <div v-else class="empty-state">
                    <i class="fas fa-search"></i>
                    <p>Nenhuma escola encontrada com o filtro aplicado</p>
                </div>
            </div>
        </div>

        <Tabela :headers="headers" :desserts="mediaAll" :title="titulo" :icon="icone" @search="buscar" v-if="showTable">
            <template v-slot:acoes>
                <v-col cols="12" md="4" class="text-right">
                    <div style="display: flex; flex-direction: row;">
                        <v-select class="year-select" :items="anoLectivoAll" v-model="anoLectivoSelected"
                            @change="carregarDados()" item-value="descricao" item-text="novadescricao"
                            label="Ano Lectivo" outlined dense hide-details></v-select>

                        <v-select class="year-select" :items="visualizacao" v-model="visualizacaoSelected"
                            @change="mudarVisualizacao()" item-value="id" item-text="descricao" label="Visualização"
                            outlined dense hide-details></v-select>
                        <v-select class="year-select" v-if="imsFiltrados.length"  :items="imsFiltrados"
                            v-model="imsAssociadoSelect" @change="filtrarIMS()" item-value="descricao"
                            item-text="descricaoFilhacao" label="Colégios" outlined dense hide-details></v-select>
                    </div>
                </v-col>
            </template>
        </Tabela>
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs'
import axios from "../../../plugins/axios";
import Tabela from "../componentes/configuracoes/Tabela-estatistica.vue";
const ls = require('local-storage')
import Swal from 'sweetalert2';

export default {
    components: {
        Tabela,
        loading: () => import("../../../components/loading.vue"),
        BarChart: {
            extends: Bar,
            props: ['chartData', 'options'],
            watch: {
                chartData: {
                    handler(newData) {
                        this.renderChart(newData, this.options)
                    },
                    deep: true
                }
            },
            mounted() {
                this.renderChart(this.chartData, this.options)
            }
        }
    },

    data() {
        return {
            anoLectivoAll: [],
            headers: [
                { text: '#', value: 'index', align: 'center' },
                { text: "Instituição", align: "left", value: "descricao" },
                { text: "Média", align: "left", value: "media" },
                { text: "IMS Associado", align: "left", value: "ims" }
            ],
            titulo: 'Média de notas por instituição ',
            icone: "mdi-school",
            visualizacao: [
                { id: 1, descricao: 'Visualizar Gráfico' },
                { id: 2, descricao: 'Visualizar Tabela' },
            ],
            imsAssociado: [
                { id: 1, descricao: 'Todos', descricaoFilhacao: 'Todos' },
                { id: 2, descricao: 'IMS-Luanda', descricaoFilhacao: 'Afilhados IMS Maianga' },
                { id: 3, descricao: 'IMS-Kalawenda', descricaoFilhacao: 'Afilhados IMS Kalawenda'},
            ],
            imsAssociadoSelect: null,
            anoLectivoSelected: ls.get('anolectivo'),
            visualizacaoSelected: { id: 1, descricao: 'Visualizar Gráfico' },
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Média das Notas',
                        backgroundColor: '#42A5F5',
                        borderColor: '#1E88E5',
                        borderWidth: 1,
                        hoverBackgroundColor: '#64B5F6',
                        hoverBorderColor: '#42A5F5',
                        data: []
                    }
                ]
            },
            chartOptions: {
                indexAxis: 'y', // Gráfico horizontal para melhor legibilidade
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        backgroundColor: '#333',
                        titleFont: { size: 14 },
                        bodyFont: { size: 12 },
                        padding: 10,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                return `Média: ${context.raw.toFixed(1)}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        max: 100,
                        grid: {
                            color: 'rgba(0,0,0,0.05)'
                        },
                        ticks: {
                            stepSize: 10
                        }
                    },
                    y: {
                        ticks: {
                            font: {
                                size: 10
                            }
                        }
                    }
                },
                animation: {
                    duration: 1000
                }
            },
            mediaAll: [],
            mediaAllArray: [],
            isLoading: false,
            searchQuery: '',
            sortOption: 'score-desc',
            currentPage: 1,
            itemsPerPage: 20,
            showTable: false
        }
    },
    computed: {
        role() {
            return ls.get('role')
        },
        instituicao() {
            return ls.get('i_id')
        },

        imsFiltrados() {
            if (this.role == 'ROLE_GP' || this.role ==  'ROLE_ADM') {
                return this.imsAssociado
            } else if (this.role == 'ROLE_DIR' && this.instituicao == 1) {
                return this.imsAssociado.filter(item => item.descricao == 'IMS-Luanda');
            } else if (this.role == 'ROLE_DIR' && this.instituicao == 144) {
                return this.imsAssociado.filter(item => item.descricao == 'IMS-Kalawenda');
            } else if  (this.role == 'ROLE_DIR' && this.instituicao != 144 && this.instituicao != 1 ) {                
                return [];
            }
        },


        filteredData() {
            let data = [...this.mediaAll];

            // Filtro por busca
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                data = data.filter(item =>
                    item.descricao.toLowerCase().includes(query)
                );
            }

            // Ordenação
            switch (this.sortOption) {
                case 'name-asc':
                    return data.sort((a, b) => a.descricao.localeCompare(b.descricao));
                case 'name-desc':
                    return data.sort((a, b) => b.descricao.localeCompare(a.descricao));
                case 'score-asc':
                    return data.sort((a, b) => a.media - b.media);
                case 'score-desc':
                default:
                    return data.sort((a, b) => b.media - a.media);
            }
        },
        filteredLabels() {
            return this.paginatedData.map(item => {
                // Limita o tamanho do label para não poluir o gráfico
                return item.descricao.length > 30
                    ? item.descricao.substring(0, 30) + '...'
                    : item.descricao;
            });
        },
        filteredChartData() {
            return {
                labels: this.filteredLabels,
                datasets: [{
                    ...this.chartData.datasets[0],
                    data: this.paginatedData.map(item => item.media)
                }]
            };
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredData.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.itemsPerPage);
        },
        startItem() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endItem() {
            const end = this.currentPage * this.itemsPerPage;
            return end > this.filteredData.length ? this.filteredData.length : end;
        },
        visiblePages() {
            const pages = [];
            const maxVisible = 5;
            let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
            let end = Math.min(this.totalPages, start + maxVisible - 1);

            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        buscar(valor) {
            console.log(valor);
        },
    },

    async created() {
        await this.carregarAnosLectivos();
        await this.carregarDados();

        if (this.role == 'ROLE_GP' || this.role ==  'ROLE_ADM') {
            this.imsAssociadoSelect = 'Todos'
        } else if (this.role == 'ROLE_DIR' && this.instituicao == 1) {
            this.imsAssociadoSelect = 'IMS-Luanda';
        } else if (this.role == 'ROLE_DIR' && this.instituicao == 144) {
            this.imsAssociadoSelect = 'IMS-Kalawenda';
        }
    },

    methods: {
        async carregarAnosLectivos() {
            this.isLoading = true;
            try {
                this.anoLectivoAll = await axios.get(`/getAnosLectivosAll`).then((res) => res.data)

            } catch (error) {
                Swal.fire('Informação', 'Erro ao carregar os anos lectivos', 'error');
            } finally {
                this.isLoading = false;
            }
        },


        async carregarDados() {
            this.isLoading = true;
            try {
                let anolectivo;

                if (this.anoLectivoSelected) {
                    anolectivo = this.anoLectivoSelected
                } else {
                    anolectivo = ls.get('anolectivo')
                }

                const response = await axios.get(`/getMediaNotaPorEscola/${anolectivo}`);
                this.mediaAllArray = response.data;
                this.mediaAll = this.mediaAllArray;

            } catch (error) {
               Swal.fire('Informação', 'Erro ao carregar os dados', 'error');
            } finally {
                this.isLoading = false;
            }
        },

        mudarVisualizacao() {
            if (this.visualizacaoSelected == 2) {
                this.showTable = true;
            } else {
                this.showTable = false;
            }
        },

        filtrarIMS() {
            if (this.imsAssociadoSelect == 'Todos') {
                this.mediaAll = this.mediaAllArray;
            } else {
                this.mediaAll = this.mediaAllArray.filter((m) => m.ims == this.imsAssociadoSelect)
            }
        },


        sortBy(field) {
            if (field === 'descricao') {
                this.sortOption = this.sortOption === 'name-asc' ? 'name-desc' : 'name-asc';
            } else {
                this.sortOption = this.sortOption === 'score-asc' ? 'score-desc' : 'score-asc';
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        goToPage(page) {
            this.currentPage = page;
        },
        toggleView() {
            this.showTable = !this.showTable;
            this.currentPage = 1; // Reset paginação ao mudar de visualização
        },
        getScoreClass(score) {
            if (score >= 80) return 'high-score';
            if (score >= 60) return 'medium-score';
            return 'low-score';
        }
    }
}
</script>

<style scoped>
.optionsContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.chart-container {
    width: 100%;
    margin: 0px auto;
    background-color: #fff;
    padding: 15px;
}

.chart-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 16px;
}

.search-filter {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.search-input {
    padding: 8px 12px;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    min-width: 250px;
    margin-right: 5px;
}

.sort-select {
    padding: 8px 12px;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    background: white;
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pagination-controls button {
    background: #f5f7fa;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    transition: all 0.2s;
}

.pagination-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-controls button:hover:not(:disabled) {
    background: #ebf2ff;
    border-color: #3b82f6;
}

.data-table {
    margin-top: 24px;
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

th,
td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #e0e6ed;
}

th {
    background-color: #f8fafc;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
}

th:hover {
    background-color: #f1f5f9;
}

tr:hover {
    background-color: #f8fafc;
}

.high-score {
    color: #10b981;
    font-weight: 500;
}

.medium-score {
    color: #f59e0b;
    font-weight: 500;
}

.low-score {
    color: #ef4444;
    font-weight: 500;
}

.table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    font-size: 0.85rem;
    color: #64748b;
}

.table-pagination {
    display: flex;
    gap: 6px;
}

.table-pagination button {
    padding: 6px 12px;
    border: 1px solid #e0e6ed;
    background: white;
    border-radius: 4px;
    cursor: pointer;
}

.table-pagination button.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
}

.view-toggle {
    margin-top: 24px;
    text-align: center;
}

.toggle-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.toggle-btn:hover {
    background: #2563eb;
}

@media (max-width: 768px) {
    .chart-controls {
        flex-direction: column;
        align-items: stretch;
    }

    .search-filter {
        flex-direction: column;
    }

    .search-input,
    .sort-select {
        width: 100%;
    }

    .pagination-controls {
        justify-content: center;
    }

    th,
    td {
        padding: 8px 12px;
    }
}

.year-select {
    margin-right: 5px;
    max-width: 200px;
}
</style>